<template>
  <section> 
    <div id="bar">
      <el-radio-group v-model="conditionType" @change="changeType">
        <el-radio-button label="LastWeek">最近一周</el-radio-button>
        <el-radio-button label="LastMonth">最近一月</el-radio-button>
        <el-radio-button label="LastYear">最近一年</el-radio-button>
      </el-radio-group>
      <el-select @change="customerChange"
        v-model="selectedCustomer"
        filterable
        remote
        reserve-keyword
        clearable
        placeholder="请输入客户关键词"
        :remote-method="getCustomers"
        :loading="loading">
        <el-option
          v-for="item in customers"
          :key="item.code"
          :label="item.name"
          :value="item.code">
        </el-option>
      </el-select>
    </div>
    <div id="chart-container" width="500px"></div>
  </section>
</template>

<style>
  #chart-container{
    position:absolute;
    width: 80%;
    height: 100%;
  }
  #bar{
    padding-left:3%
  }
</style>

<script>
import echarts from 'echarts'
export default {
  name: 'weiXinRemindMonitor',
  data() {
    return {
      conditionType: 'LastWeek',
      tableheight: (window.innerHeight - 220) + 'px',
      myChart: null,
      option: null,
      loading: false,
      selectedCustomer: '',
      customers: []
    }
  },
  methods: {
    changeType: function() {
      // 加载数据
      let url = ''
      if (this.conditionType === 'LastWeek') {
        url = 'api/Monitor/GetLastDayWeiXinRemindData?lastDay=7&appCode=' + this.selectedCustomer
      } else if (this.conditionType === 'LastMonth') {
        url = 'api/Monitor/GetLastDayWeiXinRemindData?lastDay=30&appCode=' + this.selectedCustomer
      } else if (this.conditionType === 'LastYear') {
        url = 'api/Monitor/GetLastYearWeiXinRemindData?lastYear=1&appCode=' + this.selectedCustomer
      }
      this.$ajax({
        url: url,
        success: (d, r) => {
          this.refreshChart(d)
        }
      })
    },
    loadChart: function() {
      var dom = document.getElementById('chart-container')
      this.myChart = echarts.init(dom)
      // var app = {}
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['累计发送成功数', '累计发送失败数', '当期发送成功数', '当期发送失败数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: [0, 0.0001],
            data: (function() {
              let dates = []
              for (var i = 1; i < 7; i++) {
                var d = new Date()
                d.setDate(d.getDate() - i)
                dates.unshift(d.getMonth() + '/' + d.getDate())
              }
              return dates
            })()
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '累计发送成功数',
            type: 'line',
            stack: '累计发送成功数',
            data: []
          },
          {
            name: '累计发送失败数',
            type: 'line',
            stack: '累计发送失败数',
            data: []
          },
          {
            name: '当期发送成功数',
            type: 'line',
            stack: '当期发送成功数',
            data: []
          },
          {
            name: '当期发送失败数',
            type: 'line',
            stack: '当期发送失败数',
            data: []
          }
        ]
      }

      // if (option && typeof option === 'object') {
      //   myChart.setOption(option, true)
      // }
      this.changeType()
    },
    refreshChart: function (d) {
      let option = this.option
      option.xAxis[0].data.splice(0, option.xAxis[0].data.length)
      option.series[0].data.splice(0, option.series[0].data.length)
      option.series[1].data.splice(0, option.series[1].data.length)
      option.series[2].data.splice(0, option.series[2].data.length)
      option.series[3].data.splice(0, option.series[3].data.length)
      d.forEach((item) => {
        option.xAxis[0].data.push(new Date(item.date).Format(this.conditionType === 'LastYear' ? 'yyyy/MM' : 'MM/dd'))
        option.series[0].data.push(item.totalSendedCount)
        option.series[1].data.push(item.totalLoseCount)
        option.series[2].data.push(item.sendedCount)
        option.series[3].data.push(item.loseCount)
      })
      this.myChart.setOption(option)
    },
    getCustomers: function(q) {
      if (q !== '') {
        let para = {
          keywords: q,
          pageno: 1,
          pagesize: 100,
          sortname: 'Name',
          sorttype: 'asc'
        }
        this.$ajax({
          url: 'api/Customer/GetCustomers',
          method: 'get',
          data: para,
          loadingName: 'loading',
          success: (d, r) => {
            this.customers = d
            this.loading = false
          }
        })
      }
    },
    customerChange: function() {
      this.changeType()
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableheight = (window.innerHeight - 220) + 'px'
      })()
    }
    setTimeout(this.loadChart(), 1000)
  }
}
</script>